<template>
    <div>
        <div class="pb-6 pt-4 border-b-2 border-grey-200">
            <h3 class="font-bold mb-2">Bank Details</h3>
            <div class="grid grid-cols-2 gap-2 text-sm">
                <span class="text-mediumGrey">Bank Name:</span>
                <span>{{ directDebitDetails.bank_name }}</span>
                <span class="text-mediumGrey">Bank Address:</span>
                <span>{{ formatAddress }}</span>
                <span class="text-mediumGrey">BIC:</span>
                <span>{{ directDebitDetails.bic_code }}</span>
                <template v-if="directDebitDetails.branch_name">
                    <span class="text-mediumGrey">Branch Name:</span>
                    <span>{{ directDebitDetails.branch_name }}</span>
                </template>
                <span class="text-mediumGrey">IBAN:</span>
                <span style="overflow-wrap: anywhere" class="gb_mask">{{ directDebitDetails.iban }}</span>
                <span class="text-mediumGrey">Sort Code:</span>
                <span>{{ directDebitDetails.sort_code }}</span>
            </div>
            <button class="text-green-500 underline text-xs" @click="emit('prev')">Change bank details</button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useProposalStore } from "@/stores/risk/risk";

const proposalStore = useProposalStore();

const directDebitDetails = computed(() => proposalStore.proposal.direct_debit);

const formatAddress = computed(() => {
    const { address_line_1, address_line_2, address_line_3, address_line_4, eircode } = directDebitDetails.value;
    return [address_line_1, address_line_2, address_line_3, address_line_4, eircode].filter(Boolean).join(", ");
});

const emit = defineEmits<{ (e: "prev"): void }>();
</script>
